import Moment from 'moment-timezone';
import { i18n } from '@/plugins/i18n';
import VitalityCriterion from '@/utils/classes/VitalityCategory/VitalityCriterion';


/** Score based on the number of postponed actions */
export default new VitalityCriterion({
  titleTr: 'VH_AC_POSTPMT',
  key: 'actionPostponed',
  weight: 1.5,  
  score: ({ actions }, range) => {
    const mNow = Moment();
    // Score for one actions is :
    //
    // <days_between_creation_and_original_deadline> - <days_postponed>) * 100
    // ―――――――――――――――――――――――――――――――――――――――――――――――――――――――――――――――――――――――
    //              <days_between_creation_and_original_deadline>
    //
    // Total score will be the average of each action's score
    // So if there is one action that has been postponed for 2 years and 9 other
    // actions done in the period, score = 90 / 100

    // Number of postponed actions
    let nPostponed = 0;
    // Sum of the scores of each action
    let totalScore = 0;
    // Number of completed actions
    let nTotal = 0;
    // Number of total days
    let nPostpmtDays = 0;


    for (let i = 0, len = actions.length; i < len; i++) {
      const action = actions[i];
      if (action.pdca === 4) {
        const mReso = Moment(action.actedOn);
        // Check that the action has been completed in the considered period
        if (mReso.isAfter(range.start) && mReso.isBefore(range.end)) {
          nTotal++;
          // No postponement score = 100
          if (action.nPostpmt === 0) {
            totalScore += 100;
          } else {
            const mDeadline = Moment(action.deadline);
            const mOriginalDeadline = Moment(action.originalDeadline);
            const originalLeadTime = mOriginalDeadline.diff(action.created, 'days') || 1;
            const postpmtDays = mDeadline.diff(mOriginalDeadline, 'days');
            totalScore += Math.max(originalLeadTime - postpmtDays, 0) * 100 / originalLeadTime;

            nPostpmtDays += postpmtDays;
            nPostponed++;
          }
        }
      }
    }

    const score = nTotal === 0 ? 0 : totalScore / nTotal;

    return {
      score,
      data: {
        noTopsFlops: nTotal === 0,
        noCategoryHint: nTotal === 0,
        value: score,
        nPostpmtDays,
        nPostponed,
        nTotal,
      },
    };
  },

  text(scoreData) {
    const { nPostpmtDays, nPostponed, nTotal } = scoreData;

    if (nTotal === 0) {
      return i18n.t('message.VH_AC_POSTPMT_TEXT_NONE_COMPLETED');
    }
    const suffix = i18n.t(
      'message.FOR_A_TOTAL_OF',
      { what: i18n.tc('message.N_DAYS', nPostpmtDays, { nb: nPostpmtDays }) }
    );
    return i18n.tc('message.VH_AC_POSTPMT_TEXT_ACTIONS', nPostponed, { nActions: nPostponed, suffix });
  },
});
